module.exports = ".ck-editor__editable .ck-list-bogus-paragraph{display:block}"